import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  SizeOptions
} from "@dndModels";
import { SIZE_OPTIONS } from "@dndModels/Constants";
import { SizeType } from "@dndModels/Types";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import CheckBox from "@components/input/CheckBox";

interface Props {
  obj: SizeOptions;
  onChange: (changed: SizeOptions) => void; 
  disabled: boolean;
}

export default function SizeOptionsInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {
  const [ping, setPing] = useState(false);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 6
        }}>
        <CheckBox
          name="Ignore Character Size"
          value={obj.ignore_char_size}
          disabled={disabled}
          onChange={(changed: boolean) => {
            const new_obj = obj;
            new_obj.ignore_char_size = changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox
          name="Default"
          options={SIZE_OPTIONS}
          extra_options={["None"]}
          value={obj.default_size === 0 ? "None" : `${obj.default_size}`}
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.default_size = +changed as SizeType;
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox
          name="Options"
          options={SIZE_OPTIONS}
          values={obj.size_options.map(o => `${o}`)}
          disabled={disabled}
          onChange={(changed: string[]) => {
            const new_obj = obj;
            new_obj.size_options = changed.map(o => +o as SizeType);
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
    </Grid>
  );
}
